import { useState } from "react";
import { Carousel } from "react-bootstrap";
import { Helmet } from "react-helmet";
// import { onMessageListener } from "../../firebase";
import SectionHead from "../Common/SectionHead";
import Products from "../Products/Products";
import TopSeller from "../TopSellers/TopSeller";
export default function Home(props) {
    // useEffect(() => {
    //     if (!isFirst) {
    //         if (activeItemIndex === parseInt(forPagination.to) - 3) {
    //             onLoadMore();
    //         }
    //     }
    // }, [activeItemIndex])
    // const [isTokenFound, setIsTokenFound] = useState(false);
    // const [show, setShow] = useState(false);
    // const [notification, setNotification] = useState({ title: "", body: "" });

    // onMessageListener()
    //     .then((payload) => {
    //         setShow(true);
    //         setNotification({
    //             title: payload.notification.title,
    //             body: payload.notification.body,
    //         });
    //         console.log(payload);
    //     })
    //     .catch((err) => console.log("failed: ", err));

    // useEffect(() => {
    //     let data;
    //     // function to get the token
    //     async function tokenFunc() {
    //         data = await getClientToken(setIsTokenFound)
    //         if (data) {
    //             console.log("TOken is", data);
    //         }
    //         return data;
    //     }
    //     // invoking the function to get the token
    //     tokenFunc();

    // }, [setIsTokenFound])

    const items = [
        {
            key: 1,
            src: "/assets/images/first.png",
        },
        {
            key: 2,
            src: "/assets/images/second.png",
        },
        {
            key: 3,
            src: "/assets/images/third.png",
        },
    ];
    // const jsonLdData = {
    //     "@context": "http://schema.org",
    //     "@type": "Product",
    //     name: `Home`,
    //     description:
    //         "Products - Search for your best matching thrift item according to different category and criteria. Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - Thrift Store Nepal (Thrift Shop Nepal)",
    //     url: "https://www.thriftstorenepal.com/",
    //     image: `${window.location.origin}/assets/images/og-2.png`,
    //     brand: {
    //         "@type": "Organization",
    //         name: "Thrift Store Nepal",
    //     },
    // };

    return (
        <>
            {/* {
                show ? <createNotification type="info" title={notification.title} body={notification.body} /> : null
            } */}
            <Helmet>
                <title>{`Home - Thrift Store Nepal`}</title>
                <meta
                    name="description"
                    content="Thrift Store Nepal - Buy and sell preowned clothes and other accessories  on Nepal's first digital thrift shop - Thrift Store Nepal (Thrift Shop Nepal)"
                />
                <meta property="og:title" content="Home - Thrift Store Nepal" />
                <meta
                    property="og:description"
                    content="Thrift Store Nepal - Buy and sell preowned clothes and other accessories  on Nepal's first digital thrift shop - THrift Store Nepal (Thrift Shop Nepal)"
                />
                <meta name="og:image" content="/assets/images/og-2.png" />
            </Helmet>
            <Carousel>
                {items.map((item, index) => {
                    return (
                        <Carousel.Item key={index}>
                            <img className="d-block w-100" src={item.src} alt="First slide" />
                        </Carousel.Item>
                    );
                })}
            </Carousel>
            <div className="mt-4 container">
                <SectionHead leadFirstLabel="Top" leadSecondLabel="Sellers" />
                <TopSeller />
            </div>
            <Products />
            {/* <section className="recent-section mt-5">
                <div className="container">
                    <RecentProducts firstLabel="Recently" secondLabel="Added" /> */}
            {/* <SectionHead leadFirstLabel="Clothing" leadSecondLabel="Accessories" trailingFirstLabel="View" trailingSecondLabel="All" />

                    <div className="d-flex flex-wrap">
                        {Array(10).fill().map((_, index) => {
                            return (
                                <ShimmerCard key={index} clsName="col-6 col-md-4 col-lg-3" index={index} />
                            );
                        })}
                    </div> */}
            {/* </div>
            </section > */}
        </>
    );
}
